import { render, staticRenderFns } from "./TransferMenu.vue?vue&type=template&id=4715c870&scoped=true&"
import script from "./TransferMenu.vue?vue&type=script&lang=js&"
export * from "./TransferMenu.vue?vue&type=script&lang=js&"
import style0 from "./TransferMenu.vue?vue&type=style&index=0&id=4715c870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4715c870",
  null
  
)

export default component.exports